import { cn } from "@gigpro/ui/tailwind/cn";
import type React from "react";

type MobileTopNavigationProps = {
  title: string;
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  /** Art behind the bar's content, rendered between the title and `rightSlot`; it must not take up any width. */
  decoration?: React.ReactNode;
  className?: string;
};

export const MobileTopNavigation: React.FC<MobileTopNavigationProps> = ({
  title,
  leftSlot,
  rightSlot,
  decoration,
  className,
}) => (
  <header
    style={{ viewTransitionName: "mobile-navigation" }}
    className={cn(
      "fixed inset-x-0 top-0 z-50 flex h-nav-top items-center justify-between bg-black text-white [&_button]:text-white [&_svg]:text-white [&>*:last-child]:ml-auto",
      className,
    )}
  >
    {leftSlot}
    <h1 className="min-w-0 flex-1 truncate pl-1 text-large font-semibold first:pl-3">{title}</h1>
    {/* Between the title and rightSlot: the title keys off :first-child and rightSlot off :last-child. */}
    {decoration}
    {rightSlot}
  </header>
);
